
const API_URL = process.env.REACT_APP_ADMIN_API_URL
const stageUrl = "http://203.109.113.158:8000/api/admin";
const betaUrl =  "https://betaapi.vivachefs.com:8080/api/admin";

export const MESSAGE = {
    successMessage:"success",
    errorMessage:"error",
    passwordChange: "Password change successfully",
    yearInvalid:"Invalid year",
    oldpasswordMatch : "Old password does not match with your current password.",
    profileUpdate:"Profile updated successfully!",
    emailRequired: "Please enter your email address.",
    businessemailRequired:"Please enter your business email.",
    firstnameRequired: "Please enter first name.",
    campaignNameRequired: "Please enter campaign name.",
    optionSelect:"Please select at least one permission.",
    lastnameRequired: "Please enter last name.",
    businessnameRequired:"Please enter business name.",
    validFirstname : "Please enter valid first name.",
    validLastname : "Please enter valid last name.",
    currentPassword :"Please enter current password.",
    passwordCharLimit:"Please enter valid current password.",
    passwordValidation:"Invalid password",
    passwordConfirmCharLimit:"Please enter valid both password.",
    newpasswordCharLimit:"Password must be 8 characters long, must include 1 capital, 1 small letter, 1 numeric and 1 special character.",
    passwordMatch:"Current password and new password can't be same.",
    newpasswordRequired:"Please enter new password.",
    confirmPasswordRequired:"Please enter confirm password.",
    confirmPasswordmatch :"Confirm password does not match.",
    emailPasswordCurrect :"Please enter correct email address & password.",
    emailValid : "Invalid email address.",
    passwordRequired:"Please enter your password.",
    passwordCharlimit:"Please enter eight digit password.",
    passwordReset :"Password reset successfully.",
    newpasswordMatch:"Your new password cannot be the same as the old password.",
    linkExpired:"Link is expired.",
    oldpasswordNewpasswordMatch :"Old password and new password cannot be same.",
    passwordsame:"passwordsame",
    newpasswordConfirmpasswordMatch:"New password and confirm password does not match.",
    emailMessage:"Email sent successfully.",
    emailNotexist:"Email address does not exists.",
    accountNotregister:"Account not registered. Please register first.",
    codeUse:"This Code is already used.",
    inputIdEmail:"email",
    inputlabelEmail:"Email",
    inputTypeEmail:"email",
    placeholderEmail:"john@example.com",
    inputIdPassword:"password",
    inputlabelPassword:"Password",
    inputTypeText:"text",
    inputTypePassword:"password",
    checkboxType :"checkbox",
    checkboxLabel : "Remember Me",
    inputIdNewPassword: "newPassword",
    inputlabelNewPassword:"New password",
    inputIdConfirmPassword:"confirm password",
    inputlabellConfirmPassword:"Confirm password",
    imageUploadMessage:"Uploaded file is not a valid image. Only PNG, JPG and JPEG files are allowed.",
    userUpdateMessage:"User updated successfully!",
    colorUpdateMessage:"Colour updated successfully!",
    configUpdateMessage:"Config updated successfully!",
    templateUpdateMessage:"Template updated successfully!",
    usernameExist:"Username already exist",
    emailExist:'The entered email already exists. Please use a different one.',
    agentDetailMessage:"agent details updated successfully!",
    emailExistMessage:"email-exist",
    usernameMessage:"username",
    emailCurrectMessage:"Please enter correct email address.",
    inputidFirstname:"firstname",
    inputTypeFirstname: "First Name",
    inputTypeSubtitle: "Sub Title",
    inputTypetitle: "Title",
    inputTypeRating: "Rating",
    inputTypeReview: "Review",
    inputTypeDescription:"Description",
    placeholderName:'John',
    placeholderLasrname:"Doe",
    inputidLastname:"lastname",
    deleteUser:"User deleted successfully!",
    nameRequired:"Please enter name.",
    validName:"Please enter valid name.",
    linkRequired:"Please enter link.",
    validLink:"Must be a valid real estate portal link & starting with https://",
    planTypeRequired:"Please enter planType.",
    planAmountRequired:"Please enter planAmount.",
    planFeaturesRequired:"Please enter planFeatures.",
    planDescriptionRequired:"Please enter planDescription.",
    planStatusRequired:"Please enter planStatus.",
    phoneRequired: "Please enter phone number.",
    businessphoneRequired:"Please enter  business phone number.",
    titleRequired: "Please enter Title.",
    yearRequired:"Please enter Year.",
    updateProfile:"updateProfile",
    SenderIdRequired:"Please enter senderid.",
    SmsGatewayRequired :"Please enter smsgateway.",
    ApiKeyRequired:"Please enter ApiKey.",
    profileStatusRequired:"Please select a profile status.",
    countryCodeReuired:"Please enter countrycode.",
    mobileRequired:"Please enter mobileNumber.",
    loginRequired:"Please select a social login type.",
    mobileExist:"The entered mobile number already exists. Please use a different one.",
    agentCreated:"Agent created successfully",
    domainRequired:'Please enter domain.',
    validDomain:'Please enter valid domain.',
    colourRequired: "Please enter colour.",
    validColour: "Please select or enter valid colour.",
    invalidNumber:'Invalid mobile number.',
    jobTitle:'Please enter job title.',
    agencyNameRequired:'Please enter agencyName.',
    videoLinkRequired:"Please enter videoLink.",
    realEstatePortalLinkRequired:"Please enter realEstatePortalLink.",
    addressRequired:"Please enter address.",
    cityRequired: "Please enter city.",
    subtitleRequired: "Please enter sub title.",
    descriptionRequired:"Please enter description.",
    businessRequired: "Please enter business name.",
    businessEmailRequired: "Please enter business email.",
    businessPhoneRequired: "Please enter business Phone.",
    personalPhoneRequired: "Please enter personal Phone.",
    personalEmailRequired: "Please enter personal email.",
    ratingRequired: "Please enter rating.",
    reviewRequired: "Please enter review.",
    blogFileRequired:"Please enter image.",
    imageRequired:"Please upload image.",
    inputTypeNumber: 'number',
    staffFirstNameRequired: `Please enter staff's first name.`,
    staffLastNameRequired: `Please enter staff's last name.`,
    staffEmailRequired: `Please enter staff's email`,
    staffContactNumberRequired: `Please enter staff's mobile number.`,
    staffPasswordRequired: `Please enter staff's password.`,
    staffRoleRequired: `Please select staff's role.`,
    staffStatusRequired: `Please select staff's status.`,
    notificationCollection: `${API_URL === stageUrl ? "notificationStage" : API_URL === betaUrl ? "notificationBeta" : "notification"}`,
    userCollection:`${API_URL === stageUrl ? "usersStage" : API_URL === betaUrl ? "usersBeta" : "users"}`,
    chatCollection:`${API_URL === stageUrl ? "chatsStage" : API_URL === betaUrl ? "chatsBeta" : "chats"}`,
    thumbnailMedia: `${API_URL === stageUrl ? "thumbnailStage" : API_URL === betaUrl ? "thumbnailBeta" : "thumbnail"}`,
    adminId: `${API_URL === stageUrl ? "HJbaNpRzdhgZ2pmrpHgZ" : API_URL === betaUrl ? "ZXfiVnegEgaFDpiIcwza" : "66daf4c00e3a0c01ba36b175"}`,
}